const DOORS = [
  {
    key: 'shutcho',
    title: '出張報告書',
    desc: '出張のメモをAIでまとめ、様式どおりのWordを出力します',
    screen: 'reports-shutcho',
  },
];

/** 各種報告書用の入り口。今後、報告書の種類が増えたらここに追加していく。 */
export default function ReportsHubScreen({ onNavigate, onBack }) {
  return (
    <div className="workspace">
      <div className="workspace-head reveal r1">
        <button className="back-link" type="button" onClick={onBack}>← ホームへ戻る</button>
        <h1 className="workspace-title">各種報告書</h1>
      </div>

      <div className="doors reveal r2">
        {DOORS.map((door) => (
          <button
            key={door.key}
            type="button"
            className="door"
            onClick={() => onNavigate(door.screen)}
          >
            <span className="door-title-wrap">
              <span className="door-title">{door.title}</span>
            </span>
            <span className="door-desc">{door.desc}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
